<template>
  <div class="container">
    <div class="other">
      <div class="left">
        <!-- 经营状况 -->
        <div class="condition">
          <div class="title"><span>经营状况</span><span v-if="!showCondition" @click="conditionMore('/dataCenter/dataCenter','经营状况-查看更多','1638797370')">查看更多 ></span></div>
          <!-- <conditionData v-if="!showCondition" @reset="resetGif" /> -->
          <conditionData v-if="!showCondition" @reset="resetGif" :showDetail="hadBtn.includes('persisMarketBtn')"/>
          <img v-else class="gifBg" src="../../assets/image/workPlatform/bg.gif" alt="">
        </div>
        <!--待办事项-->
        <div>
          <div class="title"><span>待办事项</span></div>
          <div class="back-refund" v-if="isKnowRefund" v-has="'waitRefund'">
            <div class="refund g-flex-center-start"  @click="handleCheckInfo('/order/orderList', '待退款订单', '1621476211')">
              <img src="https://web.nlktj.com/ty/czb-merchant-web/images/customer/refund.png" alt="">
              <span>待退款订单 <span style="color: red">({{todoForm.toRefundOrderCount}})</span></span>
            </div>
            <div class="lines"></div>
            <div class="one_refund g-flex-center-start" v-has="'waitRefund'" @click="handleCheckInfo('/order/orderList', '待退款订单', '1621476211')">
              <span>1天后自动退款 <span style="color: red">({{todoForm.oneDay || 0}})</span></span>
            </div>
            <div class="seven_refund g-flex-center-start" v-has="'waitRefund'" @click="handleCheckInfo('/order/orderList', '待退款订单', '1621476211')">
              <span>7天后自动退款 <span style="color: red">({{todoForm.sevenDay || 0}})</span></span>
            </div>
          </div>
          <div class="back-matter" :class="[isBackLength >= 3 ? 'back_four' : 'back_two']">
            <div v-if="!isKnowRefund" class="refund g-flex-center-start" :class="[isKnowRefund ? 'active_three':'active_four']" v-has="'waitRefund'" @click="handleCheckInfo('/order/orderList', '待退款订单', '1621476211')">
              <img src="https://web.nlktj.com/ty/czb-merchant-web/images/customer/refund.png" alt="">
              <span>待退款订单 <span style="color: red">({{todoForm.toRefundOrderCount}})</span></span>
            </div>
            <div class="check g-flex-center-start" :class="[isKnowRefund ? 'active_three':'active_four']" v-has="'waitInfo'" @click="handleCheckInfo('/merchant/messageManage', '待查看消息', '1621476212')">
              <img src="https://web.nlktj.com/ty/czb-merchant-web/images/customer/info.png" alt="">
              <span>待查看消息 <span style="color: red">({{todoForm.toViewMsgCount}})</span></span>
            </div>
            <div class="check g-flex-center-start" :class="[isKnowRefund ? 'active_three':'active_four']" v-has="'waitCheck'" @click="handleCheckApproval('/promotionAudit/myPromotion', '待审批单据')">
              <img src="https://web.nlktj.com/ty/merchant/active/sign.png" alt="">
              <span>待审批单据 <span style="color: red">({{formNum}})</span></span>
            </div>
            <!-- <div class="fund g-flex-center-start" :class="[isKnowRefund ? 'active_three':'active_four']" v-has="'fundBalance'" @click="handleFund">
              <img src="https://web.nlktj.com/ty/czb-merchant-web/images/customer/fund.png" alt="">
              <span>营销基金余额 <span style="color: red; text-decoration: underline; margin-right: 2px">{{todoForm.marketFundBalance || 0.00}}</span> 元<span style="color: #4B7EFE;" v-if="todoForm.marketFundBalance === null">未开通</span></span>
            </div> -->
          </div>
        </div>
        <!--热门活动-->
        <div v-if="!isAllActice">
          <div class="title"><span>热门活动</span><span @click="$router.push({ path: '/promotion/centerShow' })">查看更多 ></span></div>
          <div class="g-flx"><hotActive/> </div>
        </div>
         <!--会员营销-->
        <!-- <div v-has="'persisMarketBtn'">
          <div class="title"><span>用户营销</span></div>
          <div class="g-flx"><vipMarket :recommendPorOptions="recommendPorOptions"/></div>
        </div> -->
        <!--实时数据-->
        <!-- <div>
          <div class="title"><span>实时数据</span><span @click="$router.push({ path: '/dataCenter/dataCenter' })">查看更多 ></span></div>
          <div class="lt-matter g-flx">
            <div v-for="(item, index) in realDataList" :key="index" class="real g-flx-center">
              <span>{{item.cash}}</span>
              <span>{{item.name}}</span>
            </div>
          </div>
        </div> -->
        <!--常用功能-->
        <div>
          <div class="title"><span>常用功能</span></div>
          <div class="lt-matter g-flx">
            <div v-for="(item, index) in funcList" :key="index" class="always g-flx-center" @click="$router.push({ path: item.url })">
              <img :src="item.picUrl || 'https://web.nlktj.com/ty/merchant/usedRouteImgs/order.png'" alt="">
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
         <!--油站解决方案推荐-->
        <div v-has="'tuanOp_btn'">
          <div class="title"><span>油站解决方案推荐</span></div>
          <div class="lt-matter g-flx">
            <tuanOptimization/>
          </div>
        </div>
      </div>
      <div class="right">
        <!--重要通知-->
        <div v-if="infoList && infoList.length > 0">
          <div class="info-title g-flex-sb"><span>重要通知</span><span style="cursor: pointer;" @click="getMore">更多 ></span></div>
          <ul class="info-ul">
            <li class="info-li" @click="handleNotice(item.id)" v-for="item in infoList.slice(0, 3)" :key="item.id"><span class="word">{{item.msgTitle}}</span><span v-if="item.status !==1" class="new">new</span></li>
          </ul>
        </div>
        <!--油站学堂-->
        <!-- <div>
          <div class="info-title g-flex-sb"><span>油站学堂</span><span style="cursor: pointer;" @click="oilStudy">更多 ></span></div>
          <oilShcool />
        </div> -->
        <!--一键叫油-->
        <div>
          <div class="info-title g-flex-sb"><span>一键叫油</span><span style="cursor: pointer;" @click="getMoreOil">更多></span></div>
          <oneCallOil/>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { getToDoList, getCommonFunctiont, getCurDateRealTimeData, getStationLetterTopFive, recommendPortrayal } from '@/api/customer/index'
import { registerAndLoginXet } from '@/api/common/index'
import { formNum } from '@api/marketPromotion'
import hotActive from './components/hotActive'
// import vipMarket from './components/vipMarket'
import oneCallOil from './components/oneCallOil'
// import oilShcool from './components/oilShcool'
import conditionData from './components/conditionData'
import tuanOptimization from './components/tuanOptimization'
import { mapState } from 'vuex'
import mixin from './mixin'

export default {
  mixins: [mixin],
  data () {
    return {
      todoForm: {
        toRefundOrderCount: '', // 待退款订单数量
        toViewMsgCount: '', // 待查看消息数量
        marketFundBalance: '', // 营销基金余额(仅油站有)
      },
      formNum: null, // 待审批数量
      everyformNum: {
        day: 0, // 天天特价
        limit: 0 // 限时秒杀
      },
      funcList: [],
      realDataList: [{ cash: 0, name: '总销售额(元)'}, { cash: 0, name: '加油升数(L)'}, { cash: 0, name: '订单数量(笔)'}, { cash: 0, name: '客单价(元)'}],
      infoList: [],
      recommendPorOptions: [], // 推荐画像数据
      // isKnowRefund: true // 是否知道
      gifTimmer: null, // 动画计时器
      showCondition: true // 展示经营状况动画
    }
  },
  components: {
    hotActive,
    // vipMarket,
    oneCallOil,
    // oilShcool,
    tuanOptimization,
    conditionData
  },
   computed: {
    ...mapState({
      hadBtn: state => state.permission.hadBtn,
      userInfo: state => state.user.userInfo,
      isKnowRefund: state => state.isRefund.isKnowRefund,
    }),
    // 所有的活动都没有权限
    isAllActice () {
      return !this.hadBtn.includes('water') && !this.hadBtn.includes('daySpecial') && !this.hadBtn.includes('limitShop') && !this.hadBtn.includes('comeOrder')
    },
    // 判断代办事项有几个，切换样式
    isBackLength () {
      const isBackBtn = []
      this.hadBtn.forEach(item => {
        if (['waitRefund', 'waitInfo', 'waitCheck', 'fundBalance'].includes(item)) {
          isBackBtn.push(item)
        }
      })
      return [...new Set(isBackBtn)].length
    }
  },
  watch: {
    isKnowRefund (val) {
      if (val) {
        this.getToDoListApi()
      }
    }
  },
  mounted () {
    this.$track.pageViewEvent('工作台', '1621476177')
    this.getToDoListApi()
    this.getCommonFunctiontApi()
    this.getCurDateRealTimeDataApi()
    this.getStationLetterTopFiveApi()
    this.formNumApi()
    this.resetGif()
    // 会员营销子画像接口，商户是不调取的，油站才会调取
    if (this.hadBtn.includes('persisMarketBtn')) {
      this.recommendPortrayalApi()
    }
  },
  methods: {
    // 动画图
    resetGif () {
      this.showCondition = true
      clearTimeout(this.gifTimmer)
      this.gifTimmer = setTimeout(() => {
        this.showCondition = false
      }, 4500)
    },
    // 经营状况查看更多
    conditionMore (path, name, id) {
      this.$track.clickEvent(name, id)
      this.$router.push({ path })
    },
    // 一键加油更多埋点
    getMoreOil () {
      this.$track.clickEvent('一键加油-更多', 1636083560)
      this.getChainToken()
    },
    // 跳转到消息公告页面
    handleNotice (id) {
      this.$track.clickEvent('工作台重要通知', 1621476213)
      this.$router.push({ path: '/merchant/messageNotice', query: { id } })
    },
    // 营销基金能不能跳转
    handleFund () {
      if(this.todoForm.marketFundBalance === null) {
        this.$message.info('油站没有开通营销基金')
      } else {
        this.$track.clickEvent('营销基金-工作台', 1624962161)
        this.$router.push({ path: '/fund/marketFund' })
      }
    },
    // 待查看信息
    handleCheckInfo (path, name, id) {
      this.$track.clickEvent(name, id)
      this.$store.commit('saveCustomer/SET_SAVE_INFO', { isCheck: true })
      this.$router.push({ path })
    },
    // 待审批数量按钮处理
    handleCheckApproval (path) {
      this.$router.push({ path })
    },
    // 获取推荐画像
    async recommendPortrayalApi () {
      try {
        const { code, result: { recommends } } = await recommendPortrayal()
        if (code !== 200) return
        this.recommendPorOptions = recommends.slice(0, 3)
      } catch (error) {
        console.log(error)
      }
    },
    // 取分页获取站内信
    async getToDoListApi () {
      try { 
        const { code, result: { toRefundOrderCount, oneDay, sevenDay, toViewMsgCount, marketFundBalance } } = await getToDoList()
        if(code !== 200) return
        this.todoForm = { toRefundOrderCount, oneDay, sevenDay, toViewMsgCount, marketFundBalance }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取常用功能列表
    async getCommonFunctiontApi () {
      try { 
        const { code, result } = await getCommonFunctiont()
        if(code !== 200) return
        this.funcList = result
      } catch (e) {
        console.log(e)
      }
    },
    // 获取今日订单实时数据汇总接口
    async getCurDateRealTimeDataApi () {
      try { 
        const { code, result } = await getCurDateRealTimeData()
        if(code !== 200) return
        Object.keys(result).forEach((item, index) => {
          this.realDataList[index].cash = result[item] 
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 获取最新站内信(TOP5)
    async getStationLetterTopFiveApi () {
      try { 
        const { code, result } = await getStationLetterTopFive()
        if(code !== 200) return
        this.infoList = result
      } catch (e) {
        console.log(e)
      }
    },
    // 获取审批数量
    async formNumApi () {
      try { 
        const { code, result } = await formNum()
        if(code !== 200) return
        // 获取总待审批数量
        // const allNum = result.reduce((sum, next) => sum + next.formNum, 0)
        this.formNum = result
      } catch (e) {
        console.log(e)
      }
    },
    // 油站学堂,跳转第三方链接。
    async oilStudy () {
      this.$track.clickEvent('油站学堂-更多', '1636083558')
      try {
        const { code, result } = await registerAndLoginXet({ userId: this.userInfo.userId })
        if (code !== 200) return
        window.open(result.data.login_url)
      } catch (error) {
        console.log(error)
      }
    },
    getMore () {
      this.$track.clickEvent('工作台重要通知', 1621476213)
      this.$router.push({ path: '/merchant/messageManage' })
    }
  }
}
</script>
<style lang="less" scoped>
  .container{
    min-width: 1000px;
    min-height: 500px;
    box-sizing: border-box;
    background-color: #F8F9FD;
    .other{
      width: 100%;
      height: 344px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .left{
        width: 75%;
        margin-right: 1%;
        min-width: 750px;
        min-width: 832px;
        .condition {
          background: #FFFFFF linear-gradient(360deg, rgba(68, 105, 255, 0) 70%, rgba(68, 105, 255, 0.1) 100%);
          .gifBg {
            width: 100%;
          }
        }
        >div{
          // overflow: scroll;
          padding: 10px 20px 20px 20px;
          margin-top: 15px;
          background: #fff;
          .title{
            padding: 8px 0 15px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            >span:nth-child(1){
              // padding: 20px 0 0 20px;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #222222;
              line-height: 24px;
            }
            >span:nth-child(2){
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #4B7EFE;
              cursor: pointer;
            }
          }
        }
        .back-refund{
          width: 100%;
          margin-bottom: 16px;
          margin-left: 10px;
          display: flex;
          background: #FAFAFA;
          padding: 10px 20px;
          justify-content: flex-start;
          position: relative;
          >div{
            background: #FAFAFA;
            height: 45px;
            cursor: pointer;
            img{
              display: block;
              width: 32px;
              height: 32px;
            }
            >span{
              margin-left: 10px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #222222;
            }
          }
          .lines{
            transform:scale(0.5);
            position: absolute;
            top: 1px;
            left: 220px;
            width: 1px;
            border-right: none;
            height: 68px;
            border: 1px solid #EAEAF4;
            cursor: auto;
          }
          .one_refund, .seven_refund{
            margin-left: 100px;
            >span{
              font-weight: normal;
              font-family: PingFangSC-Regular, PingFang SC;
            }
          }
        }
        .back-matter{
          width: 100%;
          display: flex;
          justify-content: flex-start;
          >div{
            padding: 15px 20px;
            background: #FAFAFA;
            margin-left: 10px;
            cursor: pointer;
            img{
              display: block;
              width: 32px;
              height: 32px;
            }
            >span{
              margin-left: 10px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #222222;
            }
          }
          .active_four{
            width: 24%;
          }
          .active_three{
            width: 32%;
          }
        }
        .back_four{
          display: flex;
          justify-content: flex-start;
          // justify-content: space-between;
        }
        .back_two{
          display: flex;
          justify-content: flex-start;
          // justify-content: space-around;
        }
        .lt-matter{
          // margin-top: 10px;
          .real{
            height: 50px;
            >span:nth-child(1){
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #222222;
            }
            >span:nth-child(2){
              margin-top: 10px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
            }
          }
          .always{
            img{
              display: block;
              // margin-top: 10px;
              width: 64px;
              height: 64px;
            }
            span{
              margin: 10px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #222222;
            }
          }
        }
      }
      .right{
        width: 24%;
        min-width: 253px;
        >div{
          margin-top: 15px;
          background: #fff;
          padding: 10px 20px;
        }
        .info-title{
          height: 40px;
          >span:nth-child(1){
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
          }
          >span:nth-child(2){
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4B7EFE;
          }
        }
        .info-ul{
          margin: 0;
          padding: 0;
          height: 120px;
          overflow-y: auto;
          .info-li{
            display: flex;
            align-items: center;
            position: relative;
            // max-width: 250px;
            height: 40px;
            list-style: none;
            border-bottom:1px solid #F4F4F4;
            .new{
              position: absolute;
              top: 10px;
              right: 1px;
              font-size: 14px;
              padding: 1px 2px;
              background: #ff821b;
              color: #fff;
              border-radius: 2px;
            }
            .word{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              white-space: nowrap;
              text-overflow:ellipsis;
              overflow: hidden;
              color: #222222;
              padding-right: 31px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>